// Feature flags. Flip to re-enable a capability app-wide without deleting any code.
// Bitcoin (buy/pay/cash-out/send/track + BTC as a display currency) is hidden for the
// soft launch. Set to true to bring every Bitcoin feature back instantly.
export const BTC_ENABLED = false;

// Native (own) Google OAuth. Temporarily OFF so the RELIABLE Emergent-managed Google login
// is used — this is currently the admin recovery path, so it must not depend on external GCP
// origin config. Re-enable (true) after the owner has confirmed they can sign in.
export const GOOGLE_NATIVE_ENABLED = false;
